import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');
import i18n from '@plugins/i18n'

export const getters = {
  getDepartmentFields() {
    return {model: 'geographics_department', 
            label: 'Departments',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'code', label: 'DANE Code', type: 'text', sortable: true, required: true },
                { key: 'is_main', label: 'Is Main', type: 'boolean', sortable: true, required: true, formatter: (value, key, item) => {
                  return value ? i18n.t('basic.yes') : i18n.t('basic.no')
                }}
              ]}
  },
}

export const actions = {
  async fetchDepartments(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/departments/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async createDepartments(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/departments/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateDepartments(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/departments/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteDepartments(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/departments/${id}/`)
      .then((response) => {
        return response.data;
      })
  }
}